import { DateTime } from "luxon";

export enum UserEventType {
  /** Triggered when the user arrives at a step within the experience flow. */
  StepArrival,
  /** Triggered when the user arrives at a view (a session ending step) within the experience flow. */
  ViewArrival
}

export default interface IUserEvent<TValue> {
  /** Identifier for the nature of the event that was created. */
  readonly type: UserEventType;
  readonly timestamp: DateTime;
  readonly value: TValue;
}
